<template>
	<div id="configEnum">
		<el-form
			ref="form"
			:rules="rules"
			:model="form"
			label-width="120px"
			inline
		>
			<!-- 数据长度 -->
			<el-form-item class="formItem" label="数据长度" prop="byteLen">
				<el-input
					type="number"
					v-model.trim="form.byteLen"
					@keydown.native="channelInputLimit"
					class="formInput"
					size="small"
				>
					<template slot="append">字节</template>
				</el-input>
			</el-form-item>
			<!-- 枚举 -->
			<el-form-item class="formItem" label="枚举" prop="bounds">
				<div class="formEnumLine formEnumLabel clearfloat">
					<span class="formEnumInput left" style="margin-left: 28px">
						属性Key
					</span>
					<span class="formEnumInput left" style="margin-left: 20px">
						属性Value
					</span>
				</div>
				<!-- 枚举 -->
				<div
					class="formEnumLine"
					v-for="(item, index) in enumList"
					:key="index"
				>
					<el-button
						style="margin-right: 5px"
						circle
						icon="el-icon-plus"
						type="primary"
						size="mini"
						@click="handleAdd(index)"
					></el-button>
					<el-input-number
						class="formEnumNumInput"
						size="small"
						placeholder="如：0"
						v-model.trim="enumList[index].name"
					></el-input-number>
					<span class="betweenInput">~</span>
					<el-input
						class="formEnumInput"
						size="small"
						placeholder="描述"
						v-model="enumList[index].value"
					></el-input>
					<el-button
						:disabled="enumList.length == 1"
						style="margin-left: 5px"
						circle
						icon="el-icon-minus"
						size="mini"
						@click="handleSub(index)"
					></el-button>
				</div>
			</el-form-item>
			<!-- 读写类型 -->
			<el-form-item class="formItem" label="读写类型" prop="rw">
				<el-radio-group v-model="form.rw">
					<el-radio :label="3">读写</el-radio>
					<el-radio :label="1">只读</el-radio>
				</el-radio-group>
			</el-form-item>
			<!-- 数据处理 -->
			<el-form-item class="formItem" label="数据处理" prop="dataProcess">
				<el-tooltip
					effect="dark"
					content="仅展示：数据仅在设备详情页的参数列表中显示即可，上报并更新此参数。仅统计：数据上报后需要存贮作为后续统计图使用。统计并展示：设备详情页的参数列表中只显示当前最新的状态，其余存储作为历史。数据不处理：默认，即不做业务逻辑处理"
					placement="top-start"
				>
					<el-select v-model="form.dataProcess">
						<el-option
							v-for="item in dataProcessList"
							:key="item.value"
							:value="item.value"
							:label="item.label"
						></el-option>
					</el-select>
				</el-tooltip>
			</el-form-item>
			<el-form-item class="formItem" label="描述" prop="description">
				<el-input
					placeholder="请输入"
					type="textarea"
					class="formInput"
					size="small"
					v-model="form.description"
				></el-input>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
export default {
	name: "configEnum",
	data() {
		var checkByteLen = (rule, value, callback) => {
			if (Number(value) < 1 || Number(value) > 65535) {
				callback(new Error("数据长度范围为1-65535"));
			} else {
				callback();
			}
		};
		var checkBounds = (rule, value, callback) => {
			let flag = true;
			for (let i in this.enumList) {
				if (
					this.enumList[i].name == 0 ||
					this.enumList[i].value == ""
				) {
					flag = false;
				}
			}
			if (flag) {
				callback();
			} else {
				callback(new Error("请补全枚举数据"));
			}
		};
		return {
			enumList: [
				{
					name: 0,
					value: "",
				},
			],
			dataProcessList: [
				{
					value: 1,
					label: "不处理",
				},
				{
					value: 2,
					label: "统计",
				},
				{
					value: 3,
					label: "展示",
				},
				{
					value: 4,
					label: "展示与统计",
				},
			],
			rules: {
				byteLen: [
					{
						required: true,
						message: "请填写数据长度",
						trigger: "change",
					},
					{
						validator: checkByteLen,
						trigger: "blur",
					},
				],
				bounds: [
					{
						required: true,
						message: "请至少添加一组枚举类",
						trigger: "change",
					},
					{
						checkBounds: checkByteLen,
						trigger: "blur",
					},
				],
				rw: [
					{
						required: true,
						message: "请选择读写类型",
						trigger: "change",
					},
				],
				dataProcess: [
					{
						required: true,
						message: "请选择数据处理方式",
						trigger: "change",
					},
				],
			},
			form: {
				dataProcess: 1,
				byteLen: "",
				bounds: "",
				description: "",
				rw: "",
			},
		};
	},
	watch: {
		enumList: {
			deep: true,
			handler: function (val) {
				let res = "";
				val.forEach((item) => {
					if ((item.name || item.name === 0) && item.value) {
						if (res.length > 1) {
							res =
								res +
								"," +
								'"' +
								item.name +
								'":"' +
								item.value +
								'"';
						} else {
							res = '"' + item.name + '":"' + item.value + '"';
						}
					}
				});
				this.form.bounds = res ? '{"items":{' + res + "}}" : "";
			},
		},
	},
	methods: {
		assignForm: function (form) {
			let bounds = JSON.parse(form.bounds).items,
				list = [];
			for (let i in bounds) {
				list.push({
					value: bounds[i],
					name: i,
				});
			}
			for (let i in this.form) {
				this.form[i] = form[i];
			}
			if (form.dataProcess == null) {
				form.dataProcess = 1;
			}
			this.$set(this, "enumList", list);
		},
		handleAdd: function (index) {
			let list = Object.assign([], this.enumList);
			list.splice(index + 1, 0, {
				name: 0,
				value: "",
			});
			this.$set(this, "enumList", list);
		},
		handleSub: function (index) {
			let list = Object.assign([], this.enumList);
			list.splice(index, 1);
			this.$set(this, "enumList", list);
		},
		handleSubmit: function () {
			let result;
			this.$refs.form.validate((valid) => {
				if (valid) {
					result = this.form;
				} else {
					result = false;
				}
			});
			return result;
		},
		close: function () {
			this.$refs.form.resetFields();
			this.enumList = [
				{
					name: 0,
					value: "",
				},
			];
		},
		channelInputLimit(e) {
			let key = e.key;
			// 不允许输入'e'和'.'
			if (key === "e" || key === ".") {
				e.returnValue = false;
				return false;
			}
			return true;
		},
	},
};
</script>

<style scoped>
.formInput {
	width: 200px;
}
.formItem {
	width: 45%;
	vertical-align: top;
}
.formInputSmall {
	display: inline-block;
	width: 90px;
}
.betweenInput {
	display: inline-block;
	width: 20px;
	text-align: center;
	font-size: 20px;
}

.formEnumLine {
	width: 330px;
}
.formEnumInput {
	display: inline-block;
	width: 85px;
}
.formEnumNumInput {
	display: inline-block;
	width: 120px;
}
.formEnumLabel {
	text-align: center;
	font-size: 12px;
}
</style>